import React from 'react'

import {AddUser_Manager} from "../../../model/manager"
import UsersToAdd from "../../../model/collection"
import PopoverMenuOption from "../../../../../gd-components/popover-menu/popover-menu/menu-option"

type Props = {
    menuParams  : {
        manager     : AddUser_Manager
        usersToAdd  : UsersToAdd
    }
    hidePopover : func
}

export default function ModalAddUser_SectionMoreMenu(props: Props) {

    const isAllSelected = props.menuParams.usersToAdd.isAllAvailableSelected

    const onToggleSelectAll = () => {
        props.menuParams.usersToAdd.setAllAvailableSelected(!isAllSelected)
        props.menuParams.manager.reRender()
        return props.hidePopover()
    }

    return (
        <div className="ui5-popover-menu">
            <PopoverMenuOption
                option = {{
                    icon    : "i5-field-checkbox",
                    label   : isAllSelected ? 'Select none' : 'Select all',
                    onClick : onToggleSelectAll,
                }}
            />
        </div>
    )
}
